import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import CollectionsBootstrap from 'modules/attendance/lib/SettingsCollectionsBootstrap'
import { useTimeTrackingSubscriptionAddon } from 'modules/attendance/lib/attendanceFeaturesContext'

const RootPage = () => {
  const { timeTrackingNotInPlan } = useTimeTrackingSubscriptionAddon()

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => !timeTrackingNotInPlan}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
